interface QuickNoteSectionProps {
  show: boolean;
  content: string;
  processing: boolean;
  onContentChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export function QuickNoteSection({
  show,
  content,
  processing,
  onContentChange,
  onSave,
  onCancel,
}: QuickNoteSectionProps) {
  if (!show) return null;

  return (
    <div className="quick-note-section">
      <div className="quick-note-header">
        <h3>📝 Quick Note</h3>
        <p>Add a quick note about this traveler's form</p>
      </div>
      <div className="quick-note-content">
        <textarea
          value={content}
          onChange={(e) => onContentChange(e.target.value)}
          placeholder="Enter your note here... (e.g., 'Approved yellow fever vaccination', 'Need to follow up on malaria prophylaxis', 'Cleared for travel', etc.)"
          rows={3}
          className="quick-note-textarea"
        />
        <div className="quick-note-actions">
          <button
            className="save-note-btn"
            onClick={onSave}
            disabled={processing || !content.trim()}
          >
            {processing ? "Saving..." : "💾 Save Note"}
          </button>
          <button className="cancel-note-btn" onClick={onCancel}>
            ❌ Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
